import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import SearchIcon from "@mui/icons-material/Search";

import { ButtonBase } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import AutocompleteInput from "commons/ui/input/AutocompleteInput";
import Paper from "commons/ui/Paper";

import useRelatedProductsForm from "hooks/form/useRelatedProductsForm";

function RelatedProductsForm({ productId }: { productId: string }) {
    const { onDeleteIconClick, productAutocompleteHook, dragAndDropHook, formHook } =
        useRelatedProductsForm({
            productId,
        });

    const { form } = formHook;

    return (
        <GridItem className="product-container">
            <Paper>
                <GridColumn>
                    <GridRow>
                        <GridItem className={"col-xs-24-24 title-margin"}>
                            <h2>Prodotti correlati</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow alignItems="center">
                        <GridItem
                            className={
                                "col-xl-24-6 col-lg-24-8 col-xs-24-8 select-correlated-product"
                            }
                        >
                            <AutocompleteInput
                                autocompleteHook={productAutocompleteHook}
                                className={"autocomplete-no-margin"}
                                placeholder={"Seleziona i prodotti"}
                                startAdornment={<SearchIcon />}
                            />
                        </GridItem>

                        <GridItem className={"col-xl-24-18 col-lg-24-16 col-xs-24-16"}>
                            <GridRow>
                                {form.products.map((product, index) => {
                                    if (!product.toDelete) {
                                        const divProps: { [x: string]: any; className?: string } = {
                                            className: "col-xl-12-3 col-lg-12-6 col-xs-12-6",
                                        };

                                        if (dragAndDropHook !== undefined) {
                                            divProps.draggable = true;

                                            divProps.className +=
                                                " " + dragAndDropHook.classes[index]?.join(" ");

                                            divProps.onDragStart = () =>
                                                dragAndDropHook.onDragStart(index);
                                            divProps.onDragEnd = () =>
                                                dragAndDropHook.onDragEnd(index);
                                            divProps.onDragOver = (event: any) =>
                                                dragAndDropHook.onDragOver(event);
                                            divProps.onDragEnter = () =>
                                                dragAndDropHook.onDragEnter(index);
                                            divProps.onDragLeave = () =>
                                                dragAndDropHook.onDragLeave(index);
                                            divProps.onDrop = () => dragAndDropHook.onDrop(index);
                                        }

                                        return (
                                            <GridItem {...divProps} key={index}>
                                                <div className={"correlated-product"}>
                                                    <GridRow alignItems={"center"}>
                                                        <GridItem
                                                            className={
                                                                "col-xs-24-4 drag-indicator-icon"
                                                            }
                                                        >
                                                            <DragIndicatorIcon />
                                                        </GridItem>

                                                        <GridItem
                                                            className={"col-xs-24-17 product-name"}
                                                        >
                                                            {product.related_product_name}
                                                        </GridItem>

                                                        <GridItem
                                                            className={"col-xs-24-3 delete-icon"}
                                                        >
                                                            <ButtonBase
                                                                onClick={() =>
                                                                    onDeleteIconClick(
                                                                        product.related_product_id,
                                                                    )
                                                                }
                                                            >
                                                                <DeleteIcon />
                                                            </ButtonBase>
                                                        </GridItem>
                                                    </GridRow>
                                                </div>
                                            </GridItem>
                                        );
                                    }

                                    return null;
                                })}
                            </GridRow>
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridItem>
    );
}

export default RelatedProductsForm;
